import { alpha } from '@mui/material/styles';
import { CloseIcon } from './CustomIcons';

// ----------------------------------------------------------------------

export default function Chip(theme) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },

      styleOverrides: {
        root: {
          height: 32,
          borderRadius: 999,
          fontSize: theme.typography.pxToRem(12),
          fontWeight: theme.typography.fontWeightMedium,
          lineHeight: 1.5,
          border: '1px solid transparent',
          '& .MuiChip-icon, & .MuiChip-deleteIcon': { color: 'inherit', fontSize: 18 },
          '&.Mui-focusVisible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
        },
        sizeSmall: { height: 28 },
        label: { paddingLeft: 12, paddingRight: 12 },
        labelSmall: { paddingLeft: 10, paddingRight: 10 },
        clickable: { minHeight: 32 },
        filled: {
          color: theme.palette.text.secondary,
          backgroundColor: alpha(theme.palette.grey[500], 0.12),
          ...Object.fromEntries(['primary', 'secondary', 'info', 'success', 'warning', 'error'].map((color) => [
            `&.MuiChip-color${color[0].toUpperCase()}${color.slice(1)}`,
            {
              color: theme.palette[color][theme.palette.mode === 'light' ? 'dark' : 'light'],
              backgroundColor: alpha(theme.palette[color].main, 0.16),
              borderColor: alpha(theme.palette[color].main, 0.24),
              '&:hover': { backgroundColor: alpha(theme.palette[color].main, 0.24) },
            },
          ])),
        },
        colorDefault: {
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary,
          },
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          '&.MuiChip-colorPrimary': {
            borderColor: theme.palette.primary.main,
          },
          '&.MuiChip-colorSecondary': {
            borderColor: theme.palette.secondary.main,
          },
        },
        //
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark,
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark,
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark,
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark,
        },
      },
    },
  };
}
